module.exports = __webpack_public_path__ + "img/colletaral-icon.d8eb1ed2.svg";